<template>
  <div id="userTopbar" class="container">
    <!-- TOP BAR -->
    <div class="user-topbar">
      <div class="left">
        <RouterLink to="/account">
          <font-awesome-icon icon="gear" color="gray" />
        </RouterLink>
      </div>
      <div class="right level-info">
        <img src="@/assets/imgs/icons/general/levels-blue.svg" alt="Level icon" />
        <p class="level-number">
          {{ level }}
        </p>
        <div class="progress-bar">
          <div class="progress" :style="{ width: ((exp % 500) / 500) * 100 + '%' }"></div>
        </div>
      </div>
    </div>

    <!-- BOTTOM BAR -->
    <div class="user-bar">
      <div class="left">
        <RouterLink to="/account" v-if="trophies.length <= 0">
          <h2 class="username">
            {{ username }}
          </h2>
        </RouterLink>

        <!-- TROPHIES LIST -->
        <div class="trophies-list" v-if="trophies.length > 0">
          <ul>
            <li class="trophy" v-for="(trophy, index) in trophies" :key="index">
              <img :src="trophy.image" :alt="trophy.name" />
            </li>
          </ul>
        </div>
      </div>

      <div class="center">
        <div class="profile-image">
          <img :src="'./images/characters/' + avatar + '.png'" alt="Avatar" />
        </div>
      </div>

      <div class="right">
        <div class="cash">
          <div class="cash-number">
            <span v-if="cash > 999999">999.999+</span>
            <span v-else>{{ cash.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }}</span>
          </div>
          <img src="@/assets/imgs/icons/general/coins.svg" alt="Cash icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'

// All values are reactive; the store updates them in real time via onSnapshot
const userStore = useUserStore()

const avatar   = computed(() => userStore.userAvatar)
const cash     = computed(() => userStore.userCash ?? 0)
const exp      = computed(() => userStore.userExp  ?? 0)
const username = computed(() => userStore.userName)
const level = computed(() => userStore.userExp ? Math.floor(userStore.userExp / 500) + 1 : 1)
const trophies = computed(() => userStore.trophies ?? [])
</script>

<style scoped lang="scss">
@import './userTopbar.scss';
.user-stats {
  list-style: none;
  padding: 0;
  margin: 0;
}
.user-stats li {
  margin: 4px 0;
}
</style>